/**
 * 错误码常量与业务异常（附录B §1.3 / 附录C §2 令牌状态机）。
 */
export const ErrorCodes = {
  /** 令牌已过期 → 触发静默刷新 */
  TOKEN_EXPIRED: 'AUTH_401002',
  /** refresh 缺失/失效/已被轮换 → 清空状态跳登录，禁止重试循环 */
  REFRESH_INVALID: 'AUTH_401003',
  /** 刷新端点 CSRF 校验失败 → 跳登录并上报 traceId，不重试 */
  CSRF_FAILED: 'AUTH_403004',
} as const

export class BizError extends Error {
  constructor(
    readonly code: string,
    message: string,
    readonly traceId?: string,
    readonly httpStatus?: number,
  ) {
    super(message)
    this.name = 'BizError'
  }
}
